import React from 'react'
import {Route, Switch} from 'react-router-dom'

import MODES from 'constants/MODES'
import AppHeader from 'modules/AppHeader'

const RoutesNav = () => (
  <Switch>
    <Route exact path='/category/:alias/:searchValue?' render={p => <AppHeader {...p} mode={MODES.categoryItems}/>}/>
    <Route exact path='/search/:searchValue' render={p => <AppHeader {...p} mode={MODES.fullSearchResults}/>}/>
    <Route path='/' render={p => <AppHeader {...p} mode={MODES.autocomplete}/>}/>
  </Switch>
)

export default RoutesNav
